import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const stats = [
  {
    value: '30+ days',
    description: 'Typical settlement cycle before a system-driven cadence',
  },
  {
    value: '$450K+',
    description: 'In settled funds sitting undisbursed at one mid-size firm',
  },
  {
    value: '150–200',
    description: 'Provider reduction letters drafted by hand, every month',
  },
  {
    value: '10-day',
    description: 'Max automated follow-up window, with zero manual chasing',
  },
];

const Number = () => {
  return (
    <section className="numbers" aria-labelledby="numbers-heading">
      <Container>
        <Row className="justify-content-center text-center">
          <Col xs={12} lg={8}>
            <p className="numbers__eyebrow">Designed Around These Numbers</p>
            <h2 id="numbers-heading" className="numbers__title">
              The scale of what’s sitting idle.
            </h2>
            <p className="numbers__description mx-auto">
              Figures below reflect the founding case study behind Lien Logic’s design.
            </p>
          </Col>
        </Row>

        <Row className="g-3 g-lg-4">
          {stats.map((stat) => (
            <Col key={stat.value} xs={12} sm={6} xl={3}>
              <article className="numbers__card h-100">
                <p className="numbers__value">{stat.value}</p>
                <p className="numbers__card-text mb-0">{stat.description}</p>
              </article>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Number;
